// extracted by mini-css-extract-plugin
module.exports = {"selector":"E7AQJM","categoryPage":"fkjFDo","root":"THH4cr","sortWrapper":"c6uO14","floatingSortWrapper":"xtwQ8p"};